import React from 'react'

function Spinner (props) {
  return (
    <div className='spinner' />
  )
}

export default Spinner
